"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[591],{

/***/ 1317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ButtonShade; },
  "Z": function() { return /* binding */ library_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/library/utils/classNames.ts
var classNames = __webpack_require__(5368);
;// CONCATENATED MODULE: ./components/library/KeyboardShortcut.tsx



var KeyboardShortcutShade;
(function(KeyboardShortcutShade) {
    KeyboardShortcutShade["Blue"] = "Blue";
    KeyboardShortcutShade["Gray"] = "Gray";
})(KeyboardShortcutShade || (KeyboardShortcutShade = {}));
const KeyboardShortcut = (param)=>{
    let { className , children , styling ="solid" , shade ="Blue" , size =20 , disabled =false  } = param;
    const classes = {
        base: "flex items-center justify-center capitalize select-none rounded-sm font-bold whitespace-nowrap",
        size: {
            16: "h-16 min-w-[16px] px-[3.5px] text-11-14",
            20: "h-20 min-w-[20px] px-4 text-12-14",
            24: "h-24 min-w-[24px] px-6 text-base"
        },
        styling: {
            solid: {
                ["Gray"]: disabled ? "text-gray-500 bg-gray-100" : "text-gray-600 bg-gray-200 group-active:bg-gray-300",
                ["Blue"]: disabled ? "text-blue-300 bg-gray-200" : "text-blue-600 bg-blue-300 group-active:bg-blue-200"
            },
            // DECRECATED: This seems to no longer be part of our design library.
            //  Keeping for now as it looks ok and useful to me.
            outline: {
                ["Gray"]: "text-gray-400 border border-grey-400 group-active:bg-gray-300",
                ["Blue"]: "text-blue-400 border border-blue-400 group-active:bg-blue-300"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classNames/* classNames */.A)(classes.base, classes.size[size], classes.styling[styling][shade], className),
        children: children
    });
};
/* harmony default export */ var library_KeyboardShortcut = (KeyboardShortcut);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/library/utils/wrap.tsx
var wrap = __webpack_require__(3022);
;// CONCATENATED MODULE: ./components/library/Button.tsx






var ButtonShade;
(function(ButtonShade) {
    ButtonShade["Blue"] = "blue";
    ButtonShade["Gray"] = "gray";
    ButtonShade["Red"] = "red";
    ButtonShade["Yellow"] = "yellow";
    ButtonShade["Green"] = "green";
})(ButtonShade || (ButtonShade = {}));
const Button = /*#__PURE__*/ react.forwardRef(function ButtonComponent(props, ref) {
    const styling = props.styling || "outline";
    const type = props.type || "button";
    const size = props.size || 32;
    const shade = props.shade || "gray";
    const square = props.square || false;
    // For some UI buttons we don't want to want to allow focus
    // after a mouse click (which is the default behaviour). To do this we
    // use mouseDown events and preventDefualt on the event.
    let onClick;
    let onMouseDown;
    if (props.disableFocus) {
        onClick = (event)=>{
            event.preventDefault();
        };
        onMouseDown = (event)=>{
            event.preventDefault();
            if (props.onClick) {
                props === null || props === void 0 ? void 0 : props.onClick(event);
            }
        };
    } else {
        onClick = props.onClick;
        onMouseDown = undefined;
    }
    const classes = {
        base: "inline-flex justify-center items-center relative select-none group font-bold",
        content: {
            24: "text-12-14 gap-6",
            32: "text-14-16 gap-8",
            40: "text-14-16 gap-8",
            52: "text-18-28 gap-16"
        },
        // Applied to all but 'link' buttons
        // The awkward change in padding is to account for the border in outline
        //  buttons so that '40' remains 40 px tall and the width doesn't shift
        padding: {
            24: (0,classNames/* classNames */.A)(!square && "rounded-[4px]", styling === "outline" ? "py-4 px-[7px]" : "py-[5px] px-8"),
            32: (0,classNames/* classNames */.A)(!square && "rounded", styling === "outline" ? "py-[7px] px-[11px]" : "py-8 px-12"),
            40: (0,classNames/* classNames */.A)(!square && "rounded", styling === "outline" ? "py-[11px] px-[15px]" : "py-12 px-16"),
            52: (0,classNames/* classNames */.A)(!square && "rounded", styling === "outline" ? "py-[11px] px-[19px]" : "py-[12px] px-20")
        },
        icon: {
            24: "w-12 h-12",
            32: "w-16 h-16",
            40: "w-20 h-20 -my-2",
            52: "w-20 h-20"
        },
        block: "w-full",
        solid: {
            // applied to all
            base: (0,classNames/* classNames */.A)("focus:outline-none focus:ring ", shade === "blue" && "focus:ring-blue-300 active:bg-blue-700", shade === "gray" && "focus:ring-gray-300 active:bg-gray-700"),
            // applied if not disabled or active
            normal: (0,classNames/* classNames */.A)(shade === "blue" && "bg-blue-600 text-white hover:bg-blue-700", shade === "gray" && "bg-gray-600 text-white hover:bg-gray-700 "),
            disabled: "text-white bg-gray-400",
            active: (0,classNames/* classNames */.A)("text-white shadow-inner", shade === "blue" && "bg-blue-700", shade === "gray" && "bg-gray-700")
        },
        outline: {
            base: "border",
            normal: (0,classNames/* classNames */.A)(shade === "blue" && "border-blue-400 text-blue-600 hover:text-blue-700 active:bg-blue-200 active:text-blue-600", shade === "gray" && "border-gray-400 text-gray-700 hover:border-gray-500 hover:text-gray-800 active:bg-gray-200 active:text-gray-700", // These are less common shades and less thought has been put into the colors
            shade === "green" && "border-green-300 text-green-600 hover:text-green-700 active:bg-green-200 active:text-green-600", shade === "yellow" && "border-yellow-300 text-yellow-700 hover:text-yellow-800 active:bg-yellow-200 active:text-yellow-600", shade === "red" && "border-red-300 text-red-600 hover:text-red-700 active:bg-red-200 active:text-red-600"),
            disabled: "border-gray-300 text-gray-400",
            active: (0,classNames/* classNames */.A)(shade === "blue" && "bg-blue-200 text-blue-600", shade === "gray" && "bg-gray-200 text-gray-700", shade === "green" && "bg-green-200 text-green-700", shade === "yellow" && "bg-yellow-200 text-yellow-700", shade === "red" && "bg-red-200 text-red-700")
        },
        ghost: {
            base: "border-none focus:outline-none focus:ring focus:ring-blue-300 ",
            normal: shade === "blue" ? "text-blue-600 hover:text-blue-700 active:bg-blue-200 active:text-blue-600" : "text-gray-700 hover:text-gray-800 active:bg-gray-200 active:text-gray-700 dark:text-gray-500 dark:hover:text-white dark:active:text-white dark:active:bg-gray-800",
            disabled: "text-gray-400",
            // Same as outline
            active: shade === "blue" ? "bg-blue-200 text-blue-600" : "bg-gray-200 text-gray-700"
        },
        link: {
            // dark mode tacked on.
            base: "border-none focus:outline-none underline focus:ring focus:ring-blue ",
            normal: "text-gray-700 hover:text-black dark:hover:text-white dark:text-gray-200",
            disabled: "text-gray-300",
            active: ""
        },
        cursor: props.loading ? "cursor-progress" : props.disabled ? "cursor-not-allowed" : "cursor-pointer"
    };
    const isButton = !props.href;
    const Element = isButton ? "button" : "a";
    const elementSpecificProps = {};
    if (isButton) {
        elementSpecificProps["type"] = type;
    }
    return(// This is to use Next's Link component when acting as a link to enable
    // Client-side transitions. I don't think there's anything wrong with using
    // this still when the href is for an external link.
    /*#__PURE__*/ (0,jsx_runtime.jsx)(wrap/* ConditionalWrapper */.M, {
        condition: !!props.href,
        wrapper: (children)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: props.href,
                passHref: true,
                legacyBehavior: true,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Element, {
            ref: ref,
            ...elementSpecificProps,
            onClick: onClick,
            onMouseDown: onMouseDown,
            tabIndex: props.disabled || props.disableFocus ? -1 : 0,
            className: (0,classNames/* classNames */.A)(props.className, classes.base, classes.content[size], classes.padding[size], classes[styling].base, props.block && classes.block, props.disabled ? classes[styling].disabled : props.active ? classes[styling].active : classes[styling].normal, classes.cursor),
            disabled: props.disabled,
            ...props.href ? {
                href: props.href,
                target: props.target,
                rel: props.rel
            } : {},
            children: [
                props.IconLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(props.IconLeft, {
                    className: (0,classNames/* classNames */.A)(classes.icon[size], "")
                }),
                props.children,
                props.keyboard && props.keyboard.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-my-8 flex gap-4",
                    children: props.keyboard.map((key, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(library_KeyboardShortcut, {
                            shade: KeyboardShortcutShade.Blue,
                            disabled: props.disabled,
                            children: key
                        }, i))
                }),
                props.IconRight && /*#__PURE__*/ (0,jsx_runtime.jsx)(props.IconRight, {
                    className: (0,classNames/* classNames */.A)(classes.icon[size], "")
                })
            ]
        })
    }));
});
/* harmony default export */ var library_Button = (Button);


/***/ }),

/***/ 1172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ IconButtonShade; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5368);
/* harmony import */ var _utils_wrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3022);





var IconButtonShade;
(function(IconButtonShade) {
    IconButtonShade["Gray"] = "Gray";
    IconButtonShade["Black"] = "Black";
    IconButtonShade["Blue"] = "Blue";
})(IconButtonShade || (IconButtonShade = {}));
const IconButton = (props, ref)=>{
    const type = props.type || "button";
    const size = props.size || "24"; // Refers to the outer button size
    const shade = props.shade || "Black";
    const square = props.square || false;
    const classes = {
        base: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_4__/* .classNames */ .A)("inline-flex justify-center items-center relative select-none", !square && "rounded"),
        size: {
            12: "w-12 h-12",
            16: "w-16 h-16",
            20: "w-20 h-20",
            24: "w-24 h-24",
            32: "w-32 h-32",
            40: "w-40 h-40",
            48: "w-48 h-48"
        },
        icon: {
            12: "w-8 h-8",
            16: "w-8 h-8",
            20: "w-12 h-12",
            24: "w-16 h-16",
            32: "w-20 h-20",
            40: "w-20 h-20",
            48: "w-24 h-24"
        },
        styling: {
            ["Black"]: {
                base: "focus:outline-none focus:ring focus:ring-gray-200",
                normal: "text-black hover:bg-gray-100 active:bg-gray-200",
                disabled: "text-gray-400 hover:bg-gray-100",
                active: "text-black bg-gray-200 hover:bg-gray-200 active:bg-gray-200"
            },
            ["Gray"]: {
                base: "focus:outline-none focus:ring focus:ring-gray-300",
                normal: "text-gray-600 hover:bg-gray-200 active:bg-gray-300",
                disabled: "text-gray-400 hover:bg-gray-100",
                active: "text-gray-800 bg-gray-200 hover:bg-gray-200 active:bg-gray-200"
            },
            ["Blue"]: {
                base: "focus:outline-none focus:ring focus:ring-gray-300",
                normal: "text-blue-600 hover:bg-gray-200 active:bg-gray-300",
                disabled: "text-blue-400 hover:bg-gray-100",
                active: "text-blue-800 bg-gray-200 hover:bg-gray-200 active:bg-gray-200"
            }
        },
        disabled: props.isWait ? "cursor-wait" : "cursor-not-allowed"
    };
    const shadeStyling = classes.styling[shade];
    const Element = props.href ? "a" : "button";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_wrap__WEBPACK_IMPORTED_MODULE_3__/* .ConditionalWrapper */ .M, {
        condition: !!props.href,
        wrapper: (children)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: props.href,
                passHref: true,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            ref: ref,
            type: type,
            onClick: props.onClick,
            className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_4__/* .classNames */ .A)(props.className, classes.base, classes.size[size], shadeStyling.base, !props.baseStyle && props.disabled && classes.disabled, !props.baseStyle && (props.disabled ? shadeStyling.disabled : props.active ? shadeStyling.active : shadeStyling.normal)),
            disabled: props.disabled,
            style: props.style,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(props.Icon, {
                className: classes.icon[size]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(IconButton));


/***/ }),

/***/ 4305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ FeedbackIcon; },
/* harmony export */   "Bk": function() { return /* binding */ LightningIcon; },
/* harmony export */   "Du": function() { return /* binding */ RefreshIcon; },
/* harmony export */   "GJ": function() { return /* binding */ MoneyGraphArrowIncreaseIcon; },
/* harmony export */   "Ho": function() { return /* binding */ LoadingIcon; },
/* harmony export */   "Np": function() { return /* binding */ ShapeCubeIcon; },
/* harmony export */   "T3": function() { return /* binding */ ClockIcon; },
/* harmony export */   "Tx": function() { return /* binding */ BrainHeadIcon; },
/* harmony export */   "Vz": function() { return /* binding */ FlaskIcon; },
/* harmony export */   "fC": function() { return /* binding */ ArrowUpRightIcon; },
/* harmony export */   "rE": function() { return /* binding */ CheckCircleIcon; },
/* harmony export */   "te": function() { return /* binding */ DollarIcon; },
/* harmony export */   "vd": function() { return /* binding */ PencilIcon; },
/* harmony export */   "yc": function() { return /* binding */ CodeFileIcon; },
/* harmony export */   "zJ": function() { return /* binding */ AnnotateIcon; }
/* harmony export */ });
/* unused harmony exports TextIcon, PlayIcon, CircleIcon, FractionalCircleIcon, Lissajous1Icon, Lissajous2Icon, Lissajous5Icon, CommandIcon, ReturnIcon, TwitterIcon, FacebookIcon, LinkedinIcon, GithubIcon, YoutubeIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5368);


const TextIcon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M.75 12.749h10.5m4.5 4.5h7.5m-7.5 4.5V13.5a3.75 3.75 0 1 1 7.5 0v8.25m-22.5-.001V7.5a5.25 5.25 0 0 1 10.5 0v14.25",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const PlayIcon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        // Some manipulation to make the icon appear roughly in the right size and position as the others
        viewBox: "-2 0 28 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "1",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2.33801 3.25499H3.08801V3.25492L2.33801 3.25499ZM2.33801 20.745L3.08801 20.7451V20.745H2.33801ZM4.54701 22.067L4.19283 21.4059L4.19251 21.4061L4.54701 22.067ZM20.87 13.322L21.2242 13.9831L21.2244 13.983L20.87 13.322ZM20.87 10.678L21.2244 10.017L21.2242 10.0169L20.87 10.678ZM4.54701 1.93299L4.19251 2.59392L4.19283 2.59409L4.54701 1.93299ZM1.58801 3.25499V20.745H3.08801V3.25499H1.58801ZM1.58801 20.7449C1.58794 21.5362 2.00357 22.2694 2.68258 22.6758L3.45287 21.3887C3.22653 21.2532 3.08799 21.0088 3.08801 20.7451L1.58801 20.7449ZM2.68258 22.6758C3.3616 23.0822 4.20417 23.102 4.90151 22.7279L4.19251 21.4061C3.96006 21.5307 3.67921 21.5241 3.45287 21.3887L2.68258 22.6758ZM4.9012 22.7281L21.2242 13.9831L20.5158 12.6609L4.19283 21.4059L4.9012 22.7281ZM21.2244 13.983C21.9552 13.5912 22.4113 12.8292 22.4113 12H20.9113C20.9113 12.2764 20.7592 12.5304 20.5156 12.661L21.2244 13.983ZM22.4113 12C22.4113 11.1708 21.9552 10.4088 21.2244 10.017L20.5156 11.339C20.7592 11.4696 20.9113 11.7236 20.9113 12H22.4113ZM21.2242 10.0169L4.9012 1.27189L4.19283 2.59409L20.5158 11.3391L21.2242 10.0169ZM4.90151 1.27206C4.20417 0.898028 3.3616 0.91782 2.68258 1.32418L3.45287 2.6113C3.67921 2.47584 3.96006 2.46924 4.19251 2.59392L4.90151 1.27206ZM2.68258 1.32418C2.00357 1.73055 1.58794 2.46374 1.58801 3.25506L3.08801 3.25492C3.08799 2.99115 3.22653 2.74675 3.45287 2.6113L2.68258 1.32418Z"
        })
    });
const CircleIcon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ _jsx("circle", {
            strokeWidth: 2,
            cx: "12",
            cy: "12",
            r: "9"
        })
    });
const FractionalCircleIcon = (props)=>{
    const { fraction , className , ...rest } = props;
    const radius = 9;
    const circumference = 2 * radius * Math.PI;
    const arcLength = circumference * fraction;
    return /*#__PURE__*/ _jsxs("svg", {
        ...rest,
        className: classNames(className, "-rotate-90 transition-all"),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: radius,
                strokeDasharray: "".concat(arcLength, " 9999")
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: radius,
                className: "opacity-10"
            })
        ]
    });
};
const LoadingIcon = (props)=>{
    const { className , ...rest } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)("animate-spin", className),
        ...rest,
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
const Lissajous1Icon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M39.7869 71.2437C22.7862 71.2437 8.95529 57.4125 8.95529 40.4118C8.95529 23.4111 22.7862 9.58017 39.7869 9.58017C56.7877 9.58017 70.6188 23.4122 70.6188 40.4118C70.6188 57.4115 56.7877 71.2437 39.7869 71.2437ZM39.7869 12.1536C24.2056 12.1536 11.5287 24.8302 11.5287 40.4131C11.5287 55.9961 24.2053 68.6713 39.7883 68.6713C55.3712 68.6713 68.0478 55.995 68.0478 40.4131C68.0478 24.8313 55.3688 12.1536 39.7869 12.1536Z",
            fill: "currentColor"
        })
    });
const Lissajous2Icon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M60.8711 70.8361C54.8761 70.8361 50.2243 62.1582 42.5176 47.7813C41.376 45.6521 40.1686 43.4124 38.8952 41.0624C37.1738 37.9024 35.6269 34.9723 34.1308 32.1397C28.0463 20.6151 23.6503 12.2885 19.6947 12.2885C15.296 12.2877 11.7163 24.9198 11.7163 40.4468H9.14337C9.14337 25.6459 12.4445 9.71429 19.6942 9.71429C25.2018 9.71429 29.4191 17.7026 36.4067 30.9372C37.8983 33.7634 39.4431 36.686 41.1552 39.8313C42.4356 42.1814 43.6458 44.4261 44.7858 46.5654C51.5382 59.1615 56.4167 68.2615 60.8711 68.2615C64.1575 68.2615 67.8198 56.839 67.8198 40.4468H70.3933C70.393 40.7507 70.2843 70.8361 60.8711 70.8361Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.6648 70.8361C9.25152 70.8361 9.14285 40.7507 9.14285 40.4458H11.7163C11.7163 53.6034 14.57 68.2613 18.6648 68.2613C23.1189 68.2613 27.9976 59.1604 34.7501 46.5643C35.894 44.4303 37.1041 42.1856 38.3807 39.8302C40.093 36.686 41.6378 33.7634 43.1294 30.9372C50.117 17.7026 54.3344 9.71429 59.8419 9.71429C67.0914 9.71429 70.3933 25.6451 70.3933 40.4468H67.8198C67.8198 24.9188 64.2409 12.2877 59.8419 12.2877C55.8859 12.2877 51.4895 20.6143 45.4059 32.1389C43.9098 34.9723 42.3628 37.9024 40.6414 41.0616C39.363 43.4054 38.1555 45.6451 37.0191 47.7805C29.3115 62.1582 24.6598 70.8361 18.6648 70.8361Z",
                fill: "currentColor"
            })
        ]
    });
const Lissajous5Icon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        viewBox: "0 0 41 40",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_859_1195)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.08272 39.9296C2.74114 39.9292 2.40276 39.8639 2.08559 39.7371C1.70427 39.5871 1.18344 39.2291 0.867319 38.3744C-0.22785 35.4135 1.79063 28.3262 6.01689 20.2401C0.613845 10.3472 -0.688573 2.21146 1.82517 0.401581C3.75238 -0.986852 6.93105 1.33945 13.2782 9.29585C18.0854 3.64408 23.2682 0.247329 27.5799 0.247329C31.148 0.247329 34.3716 2.05636 36.6567 5.34136C39.1207 8.88322 40.423 14.0191 40.423 20.1935C40.423 33.6522 33.4427 39.9225 28.7252 39.9225C24.5802 39.9225 19.5699 38.7288 13.1509 30.9278L12.9965 31.1156C8.07786 37.0935 5.344 39.9296 3.08272 39.9296ZM14.2063 29.6349C20.2974 37.1419 24.9243 38.2862 28.7252 38.2862C32.2337 38.2862 38.7868 32.979 38.7868 20.1932C38.7868 6.67832 32.7498 1.88297 27.5799 1.88297C23.7143 1.88297 18.8538 5.20725 14.3192 10.6144C16.2882 13.1344 18.5404 16.1512 21.1259 19.7128L21.4698 20.1869L21.1315 20.6659C21.1058 20.7018 18.7034 24.0945 14.2063 29.6352V29.6349ZM6.97897 21.9455C2.83737 30.1202 1.68006 35.8557 2.40171 37.8068C2.48349 38.027 2.58644 38.176 2.68447 38.2146C4.17027 38.7997 7.1278 35.6736 11.7332 30.0761C11.86 29.9219 11.9853 29.7696 12.1089 29.619C11.1776 28.4115 10.2181 27.0658 9.22806 25.5663C8.42006 24.3425 7.67036 23.1356 6.97897 21.9455ZM7.87857 20.2213C8.70825 21.6981 9.61716 23.1858 10.5935 24.6645C11.48 26.0073 12.3375 27.2199 13.1705 28.315C16.5329 24.1612 18.6664 21.278 19.4537 20.1957C17.1061 16.9681 15.0563 14.2302 13.2588 11.9246C11.3536 14.3621 9.5259 17.16 7.87857 20.2213ZM3.01059 1.67437C2.87157 1.67437 2.80351 1.71331 2.78116 1.72923C2.25626 2.10766 1.84278 4.32137 2.97198 8.65057C3.75679 11.6587 5.12439 15.034 6.94968 18.5123C8.58329 15.5887 10.3622 12.9263 12.2118 10.5947C10.4086 8.32768 8.8796 6.53389 7.56719 5.14257C4.69466 2.09598 3.46894 1.67437 3.01059 1.67437Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M37.9123 39.9296C35.651 39.9296 32.9173 37.094 27.9985 31.1156L27.8441 30.9278C21.4251 38.7288 16.4149 39.9225 12.2697 39.9225C7.55229 39.9225 0.572021 33.6522 0.572021 20.1935C0.572021 14.019 1.87444 8.88284 4.3384 5.34132C6.62424 2.05649 9.84693 0.247288 13.415 0.247288C17.7271 0.247288 22.9096 3.64404 27.7168 9.29581C34.0638 1.33992 37.2433 -0.985539 39.1698 0.40154C41.6836 2.21141 40.3811 10.3471 34.9781 20.2404C39.2044 28.3262 41.2228 35.4134 40.1277 38.3747C39.8115 39.2291 39.2907 39.5874 38.9094 39.7374C38.5922 39.8641 38.2538 39.9293 37.9123 39.9296ZM13.415 1.8831C8.24515 1.88327 2.20834 6.67862 2.20834 20.1935C2.20834 32.9793 8.76107 38.2865 12.2699 38.2865C16.0705 38.2865 20.6977 37.1422 26.7889 29.6352C22.2919 24.0945 19.8894 20.7018 19.8636 20.6654L19.526 20.1871L19.8699 19.713C22.4548 16.1506 24.7069 13.1345 26.6766 10.6145C22.1413 5.20688 17.2806 1.88327 13.415 1.88327V1.8831ZM28.8861 29.6179C29.0103 29.7692 29.1355 29.9216 29.2618 30.0751C33.8674 35.6722 36.8213 38.7989 38.3107 38.2135C38.4085 38.1749 38.5117 38.0273 38.5933 37.8058C39.3149 35.8547 38.1578 30.1186 34.016 21.9444C33.3235 23.1333 32.5738 24.3401 31.7669 25.5649C30.7769 27.0662 29.817 28.4112 28.8861 29.6186V29.6179ZM21.5413 20.195C22.3281 21.2773 24.4622 24.1605 27.8244 28.3143C28.6567 27.2191 29.5149 26.0066 30.4015 24.6637C31.3778 23.1851 32.2861 21.6974 33.1164 20.2206C31.4691 17.1593 29.6414 14.3621 27.7362 11.9238C25.9387 14.2302 23.8889 16.9681 21.5413 20.1957V20.195ZM28.7831 10.5945C30.6328 12.9261 32.4117 15.5885 34.0455 18.5121C35.8706 15.0334 37.2382 11.6585 38.023 8.65036C39.1522 4.32116 38.7394 2.10745 38.2138 1.72902C38.1182 1.65977 37.1725 1.17026 33.428 5.14236C32.1159 6.53385 30.5866 8.32764 28.7831 10.5947V10.5945Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_859_1195",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "40",
                        height: "40",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
const CommandIcon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M23 19.3333C23 21.3586 21.3586 23 19.3333 23C17.3081 23 15.6667 21.3586 15.6667 19.3333V4.66667C15.6667 2.64144 17.3081 1 19.3333 1C21.3586 1 23 2.64144 23 4.66667C23 6.69189 21.3586 8.33333 19.3333 8.33333H4.66667C2.64144 8.33333 1 6.69189 1 4.66667C1 2.64144 2.64144 1 4.66667 1C6.69189 1 8.33333 2.64144 8.33333 4.66667V19.3333C8.33333 21.3586 6.69189 23 4.66667 23C2.64144 23 1 21.3586 1 19.3333C1 17.3081 2.64144 15.6667 4.66667 15.6667H19.3333C21.3586 15.6667 23 17.3081 23 19.3333Z",
            stroke: "currentColor",
            strokeMiterlimit: 10,
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const ReturnIcon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        viewBox: "0 0 24 25",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5.25 24.247L0.75 19.747M0.75 19.747L5.25 15.247M0.75 19.747H18.75C21.2353 19.747 23.25 17.7323 23.25 15.247V6.24698C23.25 3.7617 21.2353 1.74698 18.75 1.74698H10.5",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const TwitterIcon = (props)=>/*#__PURE__*/ _jsx("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M24 6.32327L21.745 5.35683L22.9262 2.77965L20.1772 3.6924C19.3016 2.87622 18.1526 2.41663 16.9557 2.40381C14.2894 2.40971 12.1294 4.56971 12.1235 7.23602V8.30985C8.32215 9.09374 5.00403 7.02126 1.92215 3.47763C1.38523 6.34117 1.92215 8.48882 3.53289 9.92059L0 9.38367C0.28169 11.731 2.20365 13.5399 4.56376 13.679L1.61074 14.7528C2.68456 16.9005 4.63893 17.2333 7.24832 17.4374C5.11551 18.8921 2.58102 19.643 0 19.585C13.702 25.6736 21.745 16.7286 21.745 8.84676V7.95549L24 6.32327Z",
            fill: "currentColor"
        })
    });
// Icons not really tested out.
const FacebookIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        role: "img",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "Facebook icon"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
            })
        ]
    });
const LinkedinIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        role: "img",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "LinkedIn icon"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
            })
        ]
    });
const GithubIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "GitHub icon"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
            })
        ]
    });
const YoutubeIcon = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "YouTube icon"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M23.499 6.203a3.008 3.008 0 00-2.089-2.089c-1.87-.501-9.4-.501-9.4-.501s-7.509-.01-9.399.501a3.008 3.008 0 00-2.088 2.09A31.258 31.26 0 000 12.01a31.258 31.26 0 00.523 5.785 3.008 3.008 0 002.088 2.089c1.869.502 9.4.502 9.4.502s7.508 0 9.399-.502a3.008 3.008 0 002.089-2.09 31.258 31.26 0 00.5-5.784 31.258 31.26 0 00-.5-5.808zm-13.891 9.4V8.407l6.266 3.604z"
            })
        ]
    });
// Platform grouping icons
const AnnotateIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.25 20.25H23.25",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20.25 17.25V23.25",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.25 20.25H4.25C3.42157 20.25 2.75 19.5784 2.75 18.75V4.25C2.75 3.42157 3.42157 2.75 4.25 2.75H18.75C19.5784 2.75 20.25 3.42157 20.25 4.25V14.25",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const ShapeCubeIcon = (props)=>// Necker cube
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.629 23.25C17.0265 23.2499 17.4078 23.092 17.689 22.811L22.811 17.689C23.092 17.4078 23.2499 17.0265 23.25 16.629V2.25C23.25 1.42157 22.5784 0.75 21.75 0.75H7.371C6.97345 0.750085 6.5922 0.907982 6.311 1.189L1.189 6.311C0.907982 6.5922 0.750085 6.97345 0.75 7.371V21.75C0.75 22.5784 1.42157 23.25 2.25 23.25H16.629Z",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.25 23.115V6.75",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.75 17.25H23.115",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.18945 22.811L6.75045 17.25",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.25 6.74996L22.811 1.18896",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.2498 6.75H0.884766",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.75 0.88501V17.25",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const CheckCircleIcon = (// Slightly more sparse than heroicons
props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.5 13L11.5 15L15.5 9M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const ArrowUpRightIcon = (// Slightly more sparse than heroicons
props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "12",
        height: "12",
        viewBox: "0 -1 13 13" // edited to make a bit smaller
        ,
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.5 9.5L9.5 2.5M9.5 2.5H2.90038M9.5 2.5V9.09962",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const FeedbackIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.48047 6V10",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.8809 1V15",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.48047 7L15.8805 2",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.48047 9L15.8805 14",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.28125 9.97266V9.99999C4.33718 11.8788 5.51478 13.5208 7.22856 14.1096C8.94234 14.6983 10.8266 14.1082 11.9446 12.6327",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const CodeFileIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.045 0.753052L18.0451 0.00305176H18.045V0.753052ZM19.093 1.18005L18.5689 1.71655L18.5693 1.71697L19.093 1.18005ZM22.048 4.06205L22.572 3.52547L22.5717 3.52513L22.048 4.06205ZM22.5 5.13605L21.75 5.13564V5.13605H22.5ZM14.8253 8.47272C14.5324 8.17983 14.0576 8.17983 13.7647 8.47272C13.4718 8.76561 13.4718 9.24049 13.7647 9.53338L14.8253 8.47272ZM18.045 12.7531L18.5753 13.2834C18.8682 12.9905 18.8682 12.5156 18.5753 12.2227L18.045 12.7531ZM13.7647 15.9727C13.4718 16.2656 13.4718 16.7405 13.7647 17.0334C14.0576 17.3263 14.5324 17.3263 14.8253 17.0334L13.7647 15.9727ZM10.3253 9.53338C10.6182 9.24049 10.6182 8.76561 10.3253 8.47272C10.0324 8.17983 9.55756 8.17983 9.26467 8.47272L10.3253 9.53338ZM6.045 12.7531L5.51467 12.2227C5.22178 12.5156 5.22178 12.9905 5.51467 13.2834L6.045 12.7531ZM9.26467 17.0334C9.55756 17.3263 10.0324 17.3263 10.3253 17.0334C10.6182 16.7405 10.6182 16.2656 10.3253 15.9727L9.26467 17.0334ZM21.75 21.7531C21.75 22.1673 21.4142 22.5031 21 22.5031V24.0031C22.2426 24.0031 23.25 22.9957 23.25 21.7531H21.75ZM21 22.5031H3V24.0031H21V22.5031ZM3 22.5031C2.58579 22.5031 2.25 22.1673 2.25 21.7531H0.75C0.75 22.9957 1.75736 24.0031 3 24.0031V22.5031ZM2.25 21.7531V2.25305H0.75V21.7531H2.25ZM2.25 2.25305C2.25 1.83884 2.58579 1.50305 3 1.50305V0.00305176C1.75736 0.00305176 0.75 1.01041 0.75 2.25305H2.25ZM3 1.50305H18.045V0.00305176H3V1.50305ZM18.0449 1.50305C18.2408 1.50307 18.4288 1.5797 18.5689 1.71655L19.6171 0.643552C19.1968 0.232997 18.6326 0.00312036 18.0451 0.00305176L18.0449 1.50305ZM18.5693 1.71697L21.5243 4.59897L22.5717 3.52513L19.6167 0.643131L18.5693 1.71697ZM21.524 4.59864C21.6686 4.73987 21.7501 4.9335 21.75 5.13564L23.25 5.13647C23.2503 4.53004 23.0059 3.94916 22.572 3.52547L21.524 4.59864ZM21.75 5.13605V21.7531H23.25V5.13605H21.75ZM13.7647 9.53338L17.5147 13.2834L18.5753 12.2227L14.8253 8.47272L13.7647 9.53338ZM17.5147 12.2227L13.7647 15.9727L14.8253 17.0334L18.5753 13.2834L17.5147 12.2227ZM9.26467 8.47272L5.51467 12.2227L6.57533 13.2834L10.3253 9.53338L9.26467 8.47272ZM5.51467 13.2834L9.26467 17.0334L10.3253 15.9727L6.57533 12.2227L5.51467 13.2834Z",
            fill: "currentColor"
        })
    });
const FlaskIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.726 0.75H17.226M5.301 12.75H18.651M14.226 17.25H17.226M15.726 15.75V18.75M15.726 3.75H12.726M15.726 6.75H12.726M15.726 8.25V0.75H8.226V8.25L1.489 18.615C0.889844 19.5367 0.842849 20.7124 1.36652 21.679C1.89019 22.6456 2.90063 23.2484 4 23.25H19.948C21.0481 23.2499 22.0599 22.6477 22.5845 21.6808C23.1092 20.7139 23.0625 19.5373 22.463 18.615L15.726 8.25ZM6.726 19.125C6.93272 19.1256 7.1 19.2933 7.1 19.5C7.1 19.7071 6.93311 19.875 6.726 19.875C6.51889 19.875 6.351 19.7071 6.351 19.5C6.351 19.2929 6.51889 19.125 6.726 19.125ZM9.726 16.125C9.93311 16.125 10.101 16.2929 10.101 16.5C10.101 16.7071 9.93311 16.875 9.726 16.875C9.51889 16.875 9.351 16.7071 9.351 16.5C9.351 16.2929 9.51889 16.125 9.726 16.125Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const MoneyGraphArrowIncreaseIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        viewBox: "0 0 14 14",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                    points: "9.5 3.5 13.5 3.5 13.5 7.5",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13.5,3.5,7.85,9.15a.5.5,0,0,1-.7,0l-2.3-2.3a.5.5,0,0,0-.7,0L.5,10.5",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
const BrainHeadIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.2494 23.25V16.985C22.0773 14.3652 23.011 10.2802 21.602 6.69208C20.1931 3.10391 16.7293 0.745664 12.8744 0.750006C5.73544 0.750006 4.19944 6.62801 1.64944 13.23C1.56093 13.4607 1.59158 13.7202 1.7314 13.924C1.87123 14.1277 2.10233 14.2496 2.34944 14.25H4.24944V17.25C4.24944 18.9069 5.59259 20.25 7.24944 20.25H8.74944V23.25",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.31701 7.70003C9.12158 7.59762 8.98099 7.41454 8.93247 7.19931C8.88396 6.98407 8.93241 6.75838 9.06501 6.58203C10.6137 4.5387 13.4116 3.91257 15.6835 5.10089C17.9554 6.2892 19.037 8.94448 18.242 11.382C18.1736 11.5919 18.0162 11.761 17.8118 11.8442C17.6073 11.9275 17.3766 11.9164 17.181 11.814L9.31701 7.70003Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const DollarIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.5 4.5C16.9142 4.5 17.25 4.16421 17.25 3.75C17.25 3.33579 16.9142 3 16.5 3V4.5ZM10.8 3.75V4.5V3.75ZM7.5 19.5C7.08579 19.5 6.75 19.8358 6.75 20.25C6.75 20.6642 7.08579 21 7.5 21V19.5ZM11.25 3.75C11.25 4.16421 11.5858 4.5 12 4.5C12.4142 4.5 12.75 4.16421 12.75 3.75H11.25ZM12.75 0.75C12.75 0.335786 12.4142 0 12 0C11.5858 0 11.25 0.335786 11.25 0.75H12.75ZM12.75 20.25C12.75 19.8358 12.4142 19.5 12 19.5C11.5858 19.5 11.25 19.8358 11.25 20.25H12.75ZM11.25 23.25C11.25 23.6642 11.5858 24 12 24C12.4142 24 12.75 23.6642 12.75 23.25H11.25ZM16.5 3H10.8V4.5H16.5V3ZM10.8 3C8.56325 3 6.75 4.81325 6.75 7.05H8.25C8.25 5.64167 9.39167 4.5 10.8 4.5V3ZM6.75 7.05C6.75 8.55543 7.4491 9.67077 8.39946 10.5419C9.32249 11.388 10.534 12.0496 11.6386 12.6572C12.784 13.2871 13.8225 13.863 14.587 14.5638C15.3241 15.2395 15.75 15.9804 15.75 16.95H17.25C17.25 15.4446 16.5509 14.3292 15.6005 13.4581C14.6775 12.612 13.466 11.9504 12.3614 11.3428C11.216 10.7129 10.1775 10.137 9.41304 9.4362C8.6759 8.76048 8.25 8.01957 8.25 7.05H6.75ZM15.75 16.95C15.75 18.3583 14.6083 19.5 13.2 19.5V21C15.4368 21 17.25 19.1868 17.25 16.95H15.75ZM13.2 19.5H7.5V21H13.2V19.5ZM12.75 3.75V0.75H11.25V3.75H12.75ZM11.25 20.25V23.25H12.75V20.25H11.25Z",
            fill: "currentColor"
        })
    });
const ClockIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 12H11.25C11.25 12.1989 11.329 12.3896 11.4696 12.5303L12 12ZM12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83579 11.25 8.25H12.75ZM16.1566 17.2183C16.4495 17.5112 16.9243 17.5112 17.2173 17.2184C17.5102 16.9255 17.5102 16.4507 17.2174 16.1577L16.1566 17.2183ZM12 23.25C18.2132 23.25 23.25 18.2132 23.25 12H21.75C21.75 17.3848 17.3848 21.75 12 21.75V23.25ZM23.25 12C23.25 5.7868 18.2132 0.75 12 0.75V2.25C17.3848 2.25 21.75 6.61522 21.75 12H23.25ZM12 0.75C5.7868 0.75 0.75 5.7868 0.75 12H2.25C2.25 6.61522 6.61522 2.25 12 2.25V0.75ZM0.75 12C0.75 18.2132 5.7868 23.25 12 23.25V21.75C6.61522 21.75 2.25 17.3848 2.25 12H0.75ZM12.75 12V8.25H11.25V12H12.75ZM11.4696 12.5303L16.1566 17.2183L17.2174 16.1577L12.5304 11.4697L11.4696 12.5303Z",
            fill: "currentColor"
        })
    });
const PencilIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.0938 3.34251L20.6572 7.906M3.57417 15.8614L8.14203 20.4214M21.0572 2.94252C20.4456 2.33354 19.616 1.99423 18.753 2.00007C17.89 2.00592 17.0651 2.35643 16.4618 2.97363L3.57329 15.8623L2 22L8.13759 20.4258L21.0261 7.53711C21.6434 6.9341 21.9941 6.10928 21.9999 5.2463C22.0058 4.38333 21.6663 3.55383 21.0572 2.94252Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const RefreshIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.25 14.248V18.748H0.75M18.75 9.74796V5.24796H23.25M19.032 5.24496C22.2304 8.57707 22.6526 13.6959 20.0434 17.507C17.4343 21.3181 12.5095 22.7763 8.246 21M4.967 18.751C1.77575 15.4174 1.35778 10.3033 3.96537 6.49579C6.57296 2.68823 11.4923 1.22944 15.754 2.99996",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const LightningIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        ...props,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
            points: "8 0.5 8 5.5 11.5 5.5 6 13.5 6 8.5 2.5 8.5 8 0.5",
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });


/***/ }),

/***/ 6786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ HumanloopLogo; }
/* harmony export */ });
/* unused harmony export ProgrammaticLogo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const HumanloopLogo = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        viewBox: "0 0 177 40",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.7429 12.6072C26.3435 9.54575 25.6297 7.62806 24.5619 6.74415C23.9818 6.26465 23.2942 6.08395 22.5726 6.22166C20.8521 6.55005 19.8155 9.33419 18.4528 14.2479C17.1753 9.81556 15.8422 6.45377 13.7868 6.19642V6.18053H13.2758V6.19642C11.2195 6.45377 9.88846 9.81432 8.60886 14.2482C7.24638 9.33451 6.2098 6.55005 4.48965 6.22166C3.76807 6.08395 3.08044 6.26465 2.50062 6.74415C1.43195 7.62806 0.718158 9.54575 0.319666 12.6072C0.0567052 14.6218 0.00810069 16.5678 0 17.4218V17.9583C0.00778913 18.8151 0.0563933 20.768 0.319354 22.7817C0.718158 25.8375 1.43102 27.7524 2.50031 28.6354C2.94928 29.0071 3.47769 29.2033 4.02698 29.2033C4.18226 29.203 4.33717 29.1881 4.48965 29.1588C6.20949 28.8304 7.24576 26.0469 8.60886 21.1322C9.88783 25.5649 11.2195 28.927 13.2758 29.184V29.1999H13.7871V29.184C15.8434 28.927 17.1741 25.5652 18.4531 21.1326C19.8155 26.0459 20.8521 28.8304 22.5729 29.1588C22.7257 29.1882 22.8809 29.2031 23.0365 29.2033C23.5867 29.2033 24.1151 29.0071 24.5632 28.6357C25.6315 27.7524 26.3444 25.8375 26.7441 22.7817C27.0068 20.768 27.0557 18.8151 27.0632 17.9583V17.4218C27.0544 16.5678 27.0055 14.6218 26.7429 12.6072ZM3.65591 8.14059C3.82103 8.00412 3.95937 7.96549 4.1488 8.00132C4.15441 8.00288 4.69404 8.16676 5.60007 10.6353C6.25436 12.4146 6.87593 14.7436 7.53738 17.219C7.57976 17.3769 7.62151 17.5337 7.66357 17.6904C7.62099 17.8489 7.57841 18.0082 7.53583 18.1683C6.87655 20.635 6.25374 22.9664 5.60007 24.7448C4.69404 27.214 4.1541 27.3776 4.15036 27.3788C3.95875 27.4156 3.81917 27.376 3.65372 27.2392C3.34216 26.9813 2.56761 26.0073 2.11584 22.5467C1.83543 20.3941 1.81113 18.3095 1.81051 17.6944C1.81019 13.7033 2.44423 9.14227 3.65497 8.14059H3.65591ZM25.2524 17.6944C25.2524 18.3085 25.2277 20.3935 24.947 22.5467C24.4956 26.0073 23.721 26.9813 23.4091 27.2392C23.2437 27.376 23.105 27.4156 22.9144 27.3791C22.9091 27.3791 22.3688 27.214 21.4628 24.7448C20.8085 22.963 20.1854 20.6322 19.5258 18.1627L19.3993 17.6901L19.5258 17.2177C20.1854 14.7489 20.8085 12.4171 21.4628 10.6353C22.3688 8.16676 22.9088 8.00288 22.9128 8.00163C23.1041 7.96518 23.2421 8.00443 23.407 8.1409C24.6168 9.14227 25.2505 13.7033 25.2514 17.6944H25.2524ZM11.5827 24.3816C10.8618 22.5321 10.1891 20.1131 9.53888 17.6904C10.1888 15.2692 10.8615 12.849 11.5827 10.9989C12.295 9.1728 13.0593 7.99291 13.5307 7.99291C14.002 7.99291 14.766 9.1728 15.4779 10.9989C16.1995 12.849 16.8722 15.2689 17.5221 17.6904C16.8722 20.1112 16.1995 22.5315 15.4779 24.3816C14.7663 26.2076 14.0017 27.3866 13.5307 27.3866C13.0593 27.3866 12.295 26.2076 11.5827 24.3816Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.4388 16.0388H36.6747V6.9881H34.1797V28.3845H36.6747V18.2867H48.4388V28.3845H50.9338V6.9881H48.4388V16.0388Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M64.0442 22.2564C64.0442 23.5296 63.6644 24.587 62.9048 25.4284C62.1453 26.2699 61.1393 26.6907 59.8871 26.6909C58.7577 26.6909 57.8801 26.4035 57.254 25.8288C56.628 25.254 56.3149 24.4533 56.3147 23.4266V13.0858H53.8203V23.488C53.8203 25.131 54.3027 26.4188 55.2675 27.3514C56.2323 28.284 57.5361 28.7514 59.1789 28.7534C61.129 28.7534 62.7304 27.9018 63.9829 26.1986H64.0452V28.3836H66.5398V13.0858H64.0452L64.0442 22.2564Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M85.7998 12.7159C84.8142 12.7159 83.8801 12.9675 82.9976 13.4705C82.13 13.9584 81.4155 14.6782 80.9341 15.5493H80.8718C80.1738 13.6606 78.7881 12.7161 76.7145 12.7159C75.7723 12.7097 74.8461 12.9599 74.0351 13.4397C73.2237 13.9123 72.5373 14.5724 72.0333 15.3646H71.971V13.0858H69.4766V28.3836H71.971V19.0909C71.971 17.9003 72.3968 16.889 73.2484 16.0572C74.1 15.2253 75.0392 14.8099 76.0662 14.8109C76.887 14.8109 77.5491 15.0933 78.0524 15.658C78.5557 16.2228 78.8072 16.9875 78.807 17.9521V28.3836H81.3014V19.0909C81.3014 17.8795 81.6915 16.8632 82.4716 16.0419C83.2518 15.2206 84.1657 14.81 85.2134 14.81C86.0345 14.81 86.7274 15.0923 87.2922 15.6571C87.8569 16.2219 88.1392 16.9866 88.139 17.9512V28.3836H90.6334V17.8281C90.6334 16.2067 90.192 14.9492 89.3093 14.0557C88.4265 13.1621 87.2567 12.7155 85.7998 12.7159Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M120.165 14.0404C119.22 13.1578 117.906 12.7163 116.223 12.7159C114.087 12.7159 112.404 13.5372 111.172 15.1798H111.11V13.0857H108.617V28.3836H111.11V19.2139C111.11 17.9205 111.52 16.8632 112.341 16.0419C113.162 15.2206 114.209 14.8099 115.483 14.8099C116.611 14.8099 117.494 15.0923 118.131 15.6571C118.768 16.2219 119.086 17.0174 119.086 18.0437V28.3836H121.58V17.8281C121.581 16.1859 121.109 14.9234 120.165 14.0404Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M126.846 6.9881H124.352V28.3848H126.846V6.9881Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M136.159 12.3894C133.839 12.3894 131.976 13.1901 130.57 14.7915C129.163 16.393 128.461 18.3845 128.461 20.7661C128.461 23.1477 129.164 25.1391 130.571 26.7404C131.977 28.3416 133.84 29.1422 136.16 29.1422C138.48 29.1422 140.338 28.3416 141.734 26.7404C143.13 25.1391 143.828 23.1477 143.828 20.7661C143.828 18.3845 143.13 16.393 141.734 14.7915C140.338 13.1901 138.48 12.3894 136.159 12.3894ZM139.947 25.2776C139.064 26.4584 137.801 27.0486 136.159 27.0482C134.517 27.0478 133.249 26.4576 132.356 25.2776C131.462 24.097 131.016 22.5931 131.016 20.7661C131.016 18.9391 131.462 17.4301 132.356 16.2391C133.249 15.0485 134.516 14.4531 136.159 14.4529C137.781 14.4529 139.038 15.0431 139.931 16.2235C140.824 17.4039 141.271 18.9181 141.271 20.7661C141.271 22.5933 140.83 24.0972 139.947 25.2776Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M153.035 12.3894C150.715 12.3894 148.852 13.1901 147.446 14.7915C146.04 16.393 145.336 18.3845 145.336 20.7661C145.336 23.1477 146.039 25.1391 147.446 26.7404C148.852 28.3416 150.715 29.1422 153.035 29.1422C155.355 29.1422 157.213 28.3416 158.609 26.7404C160.005 25.1391 160.703 23.1477 160.703 20.7661C160.703 18.3845 160.005 16.393 158.609 14.7915C157.213 13.1901 155.355 12.3894 153.035 12.3894ZM156.823 25.2776C155.94 26.4584 154.677 27.0486 153.035 27.0482C151.393 27.0478 150.125 26.4576 149.232 25.2776C148.339 24.097 147.892 22.5931 147.892 20.7661C147.892 18.9391 148.339 17.4301 149.232 16.2391C150.125 15.0485 151.393 14.4531 153.035 14.4529C154.656 14.4529 155.914 15.0431 156.807 16.2235C157.701 17.4039 158.148 18.9181 158.147 20.7661C158.147 22.5933 157.706 24.0972 156.823 25.2776Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M174.916 14.6529C173.663 13.1645 172.011 12.4202 169.958 12.4202C167.843 12.4202 166.139 13.2926 164.846 15.0374H164.783V12.7897H162.289V33.8232H164.783V26.8326H164.846C166.057 28.3932 167.73 29.1733 169.865 29.1731C172.021 29.1731 173.715 28.4187 174.947 26.9099C176.179 25.4011 176.795 23.3633 176.795 20.7967C176.795 18.1901 176.168 16.1422 174.916 14.6529ZM173.068 25.3546C172.288 26.5047 171.158 27.0795 169.679 27.0791C167.955 27.0791 166.683 26.5042 165.861 25.3546C165.039 24.2049 164.629 22.6959 164.629 20.8275C164.629 18.9997 165.06 17.4958 165.923 16.316C166.785 15.1362 168.048 14.5459 169.711 14.5451C171.168 14.5451 172.287 15.1251 173.067 16.2852C173.848 17.4453 174.238 18.9594 174.238 20.8275C174.238 22.6961 173.848 24.2051 173.068 25.3546V25.3546Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M100.277 12.4664C98.244 12.4664 96.6889 12.9592 95.6113 13.9447C94.5337 14.9303 93.9742 16.234 93.9329 17.8558H96.3348C96.4168 15.5153 97.7411 14.3451 100.308 14.3451C101.436 14.3451 102.314 14.5864 102.941 15.0689C103.567 15.5514 103.88 16.2443 103.88 17.1476C103.88 17.476 103.808 17.7634 103.664 18.0097C103.52 18.2561 103.366 18.4511 103.202 18.5949C103.038 18.7388 102.75 18.8671 102.34 18.9796C101.93 19.0922 101.596 19.1744 101.339 19.2261C101.082 19.2778 100.656 19.3446 100.062 19.4264C99.138 19.57 98.3784 19.7085 97.7829 19.8421C97.1476 19.9882 96.5246 20.1838 95.9198 20.4272C95.273 20.6843 94.7648 20.982 94.3953 21.3201C94.0258 21.6583 93.7229 22.0998 93.4867 22.6446C93.2506 23.189 93.1326 23.8306 93.1328 24.5694C93.1328 26.0068 93.6358 27.1052 94.6417 27.8646C95.6477 28.6239 96.9411 29.0037 98.522 29.0039C100.739 29.0039 102.505 28.1627 103.819 26.4803H103.85C103.867 26.5899 103.888 26.6956 103.912 26.7978V28.6983H106.16V17.5172C106.159 14.1502 104.198 12.4666 100.277 12.4664ZM103.911 22.8138C103.911 23.8818 103.49 24.8622 102.648 25.7549C101.806 26.6477 100.615 27.0943 99.0756 27.0947C96.8785 27.0947 95.7801 26.2327 95.7805 24.5087C95.7805 24.0571 95.8626 23.6618 96.0269 23.3229C96.1912 22.9839 96.3863 22.7119 96.6121 22.5069C96.8376 22.3019 97.1764 22.1119 97.6284 21.937C98.0184 21.7812 98.4205 21.6574 98.8307 21.5669C99.1793 21.4948 99.6617 21.3972 100.278 21.274C101.941 20.9662 103.152 20.5761 103.912 20.1038V22.8144L103.911 22.8138Z",
                fill: "currentColor"
            })
        ]
    });
const ProgrammaticLogo = (props)=>/*#__PURE__*/ _jsxs("svg", {
        ...props,
        viewBox: "0 0 171 28",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1.81129 27.9507C1.57219 27.9505 1.33532 27.9047 1.1133 27.816C0.846378 27.711 0.481795 27.4604 0.260509 26.8621C-0.506109 24.7894 0.906825 19.8284 3.86521 14.1681C0.0830777 7.24303 -0.828615 1.54803 0.931005 0.281119C2.28005 -0.690785 4.50512 0.937628 8.94814 6.50711C12.3132 2.55087 15.9411 0.173143 18.9593 0.173143C21.457 0.173143 23.7135 1.43946 25.3131 3.73896C27.0379 6.21826 27.9495 9.81336 27.9495 14.1355C27.9495 23.5566 23.0633 27.9458 19.761 27.9458C16.8596 27.9458 13.3523 27.1102 8.85901 21.6495L8.75092 21.7809C5.30789 25.9654 3.39419 27.9507 1.81129 27.9507ZM9.59778 20.7444C13.8616 25.9993 17.1004 26.8003 19.761 26.8003C22.217 26.8003 26.8041 23.0853 26.8041 14.1352C26.8041 4.67483 22.5783 1.31809 18.9593 1.31809C16.2534 1.31809 12.851 3.64509 9.67683 7.43006C11.0552 9.19407 12.6317 11.3058 14.4415 13.799L14.6823 14.1309L14.4454 14.4662C14.4274 14.4913 12.7458 16.8662 9.59778 20.7447V20.7444ZM4.53866 15.3619C1.63955 21.0841 0.829429 25.099 1.33458 26.4648C1.39183 26.6189 1.46389 26.7232 1.53252 26.7502C2.57257 27.1598 4.64285 24.9715 7.8666 21.0533C7.95542 20.9454 8.04309 20.8387 8.12961 20.7333C7.47772 19.8881 6.80604 18.9461 6.11303 17.8964C5.54743 17.0398 5.02264 16.1949 4.53866 15.3619ZM5.16839 14.1549C5.74916 15.1887 6.3854 16.2301 7.06881 17.2651C7.68941 18.2052 8.28962 19.0539 8.87276 19.8205C11.2264 16.9129 12.7198 14.8946 13.271 14.137C11.6276 11.8777 10.1928 9.96116 8.93451 8.34721C7.60087 10.0535 6.32151 12.012 5.16839 14.1549ZM1.7608 1.17207C1.66349 1.17207 1.61584 1.19933 1.6002 1.21047C1.23277 1.47538 0.943331 3.02497 1.73377 6.05541C2.28314 8.16112 3.24046 10.5238 4.51816 12.9587C5.66169 10.9121 6.90691 9.0484 8.20167 7.41631C6.93938 5.82938 5.8691 4.57373 4.95042 3.59981C2.93965 1.4672 2.08164 1.17207 1.7608 1.17207Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M26.185 27.9507C24.6021 27.9507 22.6886 25.9658 19.2454 21.7809L19.1373 21.6495C14.644 27.1102 11.1369 27.9458 8.23528 27.9458C4.93306 27.9458 0.046875 23.5566 0.046875 14.1355C0.046875 9.81336 0.958568 6.21802 2.68334 3.73896C4.28343 1.43958 6.53931 0.173138 9.03698 0.173138C12.0555 0.173138 15.6831 2.55087 19.0482 6.50711C23.4911 0.937979 25.7168 -0.689841 27.0653 0.281115C28.8249 1.54803 27.9133 7.24303 24.1311 14.1683C27.0895 19.8284 28.5024 24.7895 27.7358 26.8623C27.5145 27.4604 27.15 27.7112 26.883 27.8162C26.661 27.9049 26.4241 27.9505 26.185 27.9507V27.9507ZM9.03698 1.31821C5.41807 1.31833 1.1923 4.67507 1.1923 14.1355C1.1923 23.0855 5.77921 26.8006 8.2354 26.8006C10.8958 26.8006 14.1349 25.9996 18.3987 20.7447C15.2508 16.8662 13.569 14.4913 13.551 14.4658L13.3147 14.131L13.5554 13.7991C15.3648 11.3055 16.9413 9.19418 18.3201 7.43018C15.1454 3.64485 11.7429 1.31833 9.03698 1.31833V1.31821ZM19.8667 20.7326C19.9536 20.8385 20.0413 20.9451 20.1297 21.0526C23.3536 24.9706 25.4214 27.1592 26.4639 26.7495C26.5324 26.7225 26.6046 26.6191 26.6618 26.4641C27.1669 25.0983 26.3569 21.0831 23.4577 15.3612C22.9729 16.1934 22.4481 17.0381 21.8833 17.8954C21.1903 18.9464 20.5184 19.8879 19.8667 20.7331V20.7326ZM14.7253 14.1366C15.2761 14.8942 16.77 16.9124 19.1236 19.8201C19.7061 19.0534 20.3069 18.2047 20.9275 17.2647C21.6109 16.2296 22.2467 15.1882 22.8279 14.1544C21.6748 12.0115 20.3955 10.0535 19.0618 8.34673C17.8036 9.96116 16.3687 11.8777 14.7253 14.137V14.1366ZM19.7947 7.41619C21.0894 9.04828 22.3346 10.912 23.4783 12.9585C24.7559 10.5234 25.7132 8.161 26.2626 6.05529C27.053 3.02485 26.764 1.47525 26.3961 1.21035C26.3292 1.16187 25.6672 0.819217 23.046 3.59969C22.1276 4.57373 21.0571 5.82938 19.7947 7.41631V7.41619Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M38.0312 22.4H40.0472V15.68H44.4152C47.9096 15.68 49.5896 13.9104 49.5896 10.976C49.5896 9.7664 49.1864 8.7136 48.5144 7.9296C47.6856 6.944 46.3864 6.384 44.7064 6.384H38.0312V22.4ZM40.0472 8.1312H44.3704C46.4088 8.1312 47.596 9.1392 47.596 11.0656C47.596 12.9024 46.5208 14.0448 44.2584 14.0448H40.0472V8.1312Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M53.0737 10.8192H51.2593V22.4H53.0737V15.9712C53.0737 13.7984 54.6417 12.4544 56.4337 12.4544C56.7921 12.4544 56.9713 12.4768 57.2401 12.5664H57.3073V10.8192C57.0833 10.7296 56.9041 10.6848 56.5681 10.6848C55.0225 10.6848 53.8129 11.6256 53.1185 12.7456H53.0737V10.8192Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M63.4503 22.7136C66.9223 22.7136 69.0279 19.9808 69.0279 16.6208C69.0279 13.2608 66.9223 10.528 63.4503 10.528C60.0007 10.528 57.8503 13.2608 57.8503 16.6208C57.8503 19.9808 60.0007 22.7136 63.4503 22.7136ZM63.4503 21.1904C60.9863 21.1904 59.7095 19.1744 59.7095 16.6208C59.7095 14.0672 60.9863 12.0288 63.4503 12.0288C65.9143 12.0288 67.1687 14.0672 67.1687 16.6208C67.1687 19.1744 65.9143 21.1904 63.4503 21.1904Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M75.4518 26.2528C78.5206 26.2528 80.5366 24.8192 80.5366 21.7728V10.8192H78.7222V12.2976H78.6774C77.8934 11.2 76.8182 10.5504 75.1382 10.5504C72.4502 10.5504 70.1878 12.656 70.1878 16.2624C70.1878 19.6 72.2486 21.9968 75.2502 21.9968C76.9078 21.9968 77.8262 21.3024 78.6774 20.2048H78.7222V21.84C78.7222 23.856 77.535 24.8192 75.407 24.8192C73.615 24.8192 72.4054 24.3264 72.2262 23.0496H70.5462C70.7478 25.0432 72.4502 26.2528 75.4518 26.2528ZM75.3398 20.4736C73.1894 20.4736 72.047 18.816 72.047 16.2848C72.047 13.776 73.1446 12.0736 75.3174 12.0736C77.7814 12.0736 78.8566 13.6416 78.8566 16.1728C78.8566 18.6144 78.0054 20.4736 75.3398 20.4736Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M84.8143 10.8192H82.9999V22.4H84.8143V15.9712C84.8143 13.7984 86.3823 12.4544 88.1743 12.4544C88.5327 12.4544 88.7119 12.4768 88.9807 12.5664H89.0479V10.8192C88.8239 10.7296 88.6447 10.6848 88.3087 10.6848C86.7631 10.6848 85.5535 11.6256 84.8591 12.7456H84.8143V10.8192Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M99.335 22.512C99.8054 22.512 100.097 22.4224 100.321 22.3328V21.0112H100.253C99.2454 21.2352 99.0214 20.72 99.0214 19.7792V14.2688C99.0214 11.5136 97.207 10.5952 94.743 10.5952C91.6742 10.5952 90.1958 12.2752 90.1286 14.5152H91.8758C91.943 12.768 92.8838 11.9616 94.7654 11.9616C96.423 11.9616 97.3638 12.7008 97.3638 14C97.3638 15.2544 96.2214 15.4112 94.5862 15.6576C91.6966 16.1056 89.5462 16.6656 89.5462 19.3984C89.5462 21.5936 91.271 22.624 93.4662 22.624C95.4374 22.624 96.6246 21.6832 97.319 20.7872H97.3414C97.5206 21.9744 98.1478 22.512 99.335 22.512ZM93.8694 21.2352C92.6822 21.2352 91.4726 20.8992 91.4726 19.3536C91.4726 17.6512 92.9286 17.3376 94.743 17.0016C95.7286 16.8224 96.7814 16.5312 97.3862 16.1504V18.1216C97.3862 19.4656 96.2886 21.2352 93.8694 21.2352Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M101.659 22.4H103.474V15.1872C103.474 13.3728 105.042 12.0736 106.453 12.0736C107.64 12.0736 108.447 12.9248 108.447 14.3584V22.4H110.261V15.1872C110.261 13.3728 111.605 12.0736 113.106 12.0736C114.271 12.0736 115.234 12.9248 115.234 14.3584V22.4H117.048V14.2688C117.048 11.872 115.592 10.5504 113.531 10.5504C112.12 10.5504 110.731 11.2896 109.992 12.6112H109.947C109.455 11.2672 108.335 10.5504 106.923 10.5504C105.467 10.5504 104.235 11.3568 103.519 12.4768H103.474V10.8192H101.659V22.4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M119.444 22.4H121.258V15.1872C121.258 13.3728 122.826 12.0736 124.237 12.0736C125.424 12.0736 126.231 12.9248 126.231 14.3584V22.4H128.045V15.1872C128.045 13.3728 129.389 12.0736 130.89 12.0736C132.055 12.0736 133.018 12.9248 133.018 14.3584V22.4H134.832V14.2688C134.832 11.872 133.376 10.5504 131.316 10.5504C129.904 10.5504 128.516 11.2896 127.776 12.6112H127.732C127.239 11.2672 126.119 10.5504 124.708 10.5504C123.252 10.5504 122.02 11.3568 121.303 12.4768H121.258V10.8192H119.444V22.4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M146.322 22.512C146.793 22.512 147.084 22.4224 147.308 22.3328V21.0112H147.241C146.233 21.2352 146.009 20.72 146.009 19.7792V14.2688C146.009 11.5136 144.194 10.5952 141.73 10.5952C138.662 10.5952 137.183 12.2752 137.116 14.5152H138.863C138.93 12.768 139.871 11.9616 141.753 11.9616C143.41 11.9616 144.351 12.7008 144.351 14C144.351 15.2544 143.209 15.4112 141.574 15.6576C138.684 16.1056 136.534 16.6656 136.534 19.3984C136.534 21.5936 138.258 22.624 140.454 22.624C142.425 22.624 143.612 21.6832 144.306 20.7872H144.329C144.508 21.9744 145.135 22.512 146.322 22.512ZM140.857 21.2352C139.67 21.2352 138.46 20.8992 138.46 19.3536C138.46 17.6512 139.916 17.3376 141.73 17.0016C142.716 16.8224 143.769 16.5312 144.374 16.1504V18.1216C144.374 19.4656 143.276 21.2352 140.857 21.2352Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M147.689 12.2976H149.369V20.2272C149.369 21.8624 150.444 22.4672 151.922 22.4672C152.46 22.4672 152.953 22.4 153.378 22.3104V20.7424H153.311C153.11 20.8096 152.706 20.8992 152.348 20.8992C151.609 20.8992 151.183 20.6304 151.183 19.824V12.2976H153.423V10.8192H151.183V7.168H149.369V10.8192H147.689V12.2976Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M155.297 22.4H157.111V10.8192H155.297V22.4ZM155.297 8.624H157.111V6.384H155.297V8.624Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M164.535 22.7136C167.424 22.7136 169.239 21.1008 169.485 18.3232H167.693C167.536 20.1152 166.416 21.1904 164.535 21.1904C162.071 21.1904 160.794 19.1744 160.794 16.6208C160.794 14.0672 162.071 12.0288 164.535 12.0288C166.282 12.0288 167.38 12.992 167.648 14.56H169.485C169.082 12.096 167.268 10.528 164.535 10.528C161.085 10.528 158.935 13.2608 158.935 16.6208C158.935 19.9808 161.085 22.7136 164.535 22.7136Z",
                fill: "currentColor"
            })
        ]
    });


/***/ }),

/***/ 5368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ classNames; }
/* harmony export */ });
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}


/***/ }),

/***/ 3022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ConditionalWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const ConditionalWrapper = (param)=>{
    let { condition , wrapper , children  } = param;
    return condition ? wrapper(children) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};


/***/ }),

/***/ 8680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ GITHUB_LINK; },
/* harmony export */   "Fg": function() { return /* binding */ CAREERS_LINK; },
/* harmony export */   "Kx": function() { return /* binding */ ABOUT_PAGE_LINK; },
/* harmony export */   "PH": function() { return /* binding */ HUMANLOOP_DOCS_LINK; },
/* harmony export */   "Qf": function() { return /* binding */ HUMANLOOP_API_DOCS_LINK; },
/* harmony export */   "at": function() { return /* binding */ LINKEDIN_LINK; },
/* harmony export */   "fm": function() { return /* binding */ HOMEPAGE_LINK; },
/* harmony export */   "iA": function() { return /* binding */ LLM_TYPEFORM; },
/* harmony export */   "rm": function() { return /* binding */ HUMANLOOP_TYPEFORM; },
/* harmony export */   "t9": function() { return /* binding */ HUMANLOOP_APP_LOGIN; },
/* harmony export */   "v": function() { return /* binding */ TWITTER_LINK; },
/* harmony export */   "v9": function() { return /* binding */ SLACK_LINK; }
/* harmony export */ });
/* unused harmony exports TEXT_IS_PRIMARY_COLUMN, PLACEHOLDER_DASHES, PRICING_PAGE_LINK, PLATFORM_PAGE_LINK, PROGRAMMATIC_PAGE_LINK, PROGRAMMATIC_DOCS_LINK, HUMANLOOP_APP_LINK, HUMANLOOP_APP_SIGNUP, HUMANLOOP_CAREERS_LINK, PROGRAMMATIC_TYPEFORM, PANE_BREAKPOINT_2XS, PANE_BREAKPOINT_XS */
// TODO: Remove implicit assumption that "text" column is primary text column.
const TEXT_IS_PRIMARY_COLUMN = "text";
const PLACEHOLDER_DASHES = "– –";
// Internal links
const HOMEPAGE_LINK = "/";
const PRICING_PAGE_LINK = "/pricing";
const PLATFORM_PAGE_LINK = "/";
const PROGRAMMATIC_PAGE_LINK = "/programmatic";
const ABOUT_PAGE_LINK = "/about";
// Subdomains
const CAREERS_LINK = "https://www.ycombinator.com/companies/humanloop/jobs";
const PROGRAMMATIC_DOCS_LINK = "https://docs.programmatic.humanloop.com";
const HUMANLOOP_DOCS_LINK = "https://docs.humanloop.com";
const HUMANLOOP_API_DOCS_LINK = "https://docs.humanloop.com/api";
const HUMANLOOP_APP_LINK = "https://app.humanloop.com";
const HUMANLOOP_APP_SIGNUP = "https://app.humanloop.com/signup";
const HUMANLOOP_APP_LOGIN = "https://app.humanloop.com/login";
const HUMANLOOP_CAREERS_LINK = "https://careers.humanloop.com";
// Socials and marketing
const GITHUB_LINK = "https://github.com/humanloop";
const LINKEDIN_LINK = "https://linkedin.com/humanloop";
const TWITTER_LINK = "https://twitter.com/humanloop";
const SLACK_LINK = "https://join.slack.com/t/humanloop-community/shared_invite/zt-15bpaukat-w99Ns5wyQiuKVPSxyLqHlQ";
const PROGRAMMATIC_TYPEFORM = "https://qnar0f4q62y.typeform.com/to/LlpY8vSt";
const HUMANLOOP_TYPEFORM = "https://qnar0f4q62y.typeform.com/humanloop";
const LLM_TYPEFORM = "https://qnar0f4q62y.typeform.com/humanloop-llm";
// These sizes are meant to extend the spacings set in tailwind.
const PANE_BREAKPOINT_2XS = 350;
const PANE_BREAKPOINT_XS = 475;


/***/ })

}]);